export const GALLERY_DOCUMENT_TITLE_SUFFIX = 'Diana Perova, Photographer in Porto';
export const GALLERY_META_DESCRIPTION_MAX_LENGTH = 160;
/**
 * Gallery headings are editorial content. The browser/SEO title is a derived
 * presentation value and must never become a second editable Gallery name.
 */
export function galleryDocumentTitle(galleryName) {
    return `${galleryName.trim()} | ${GALLERY_DOCUMENT_TITLE_SUFFIX}`;
}
export function galleryDescriptionText(description, fallback = '') {
    if (!description)
        return normalizeWhitespace(fallback);
    const values = description.children.flatMap((block) => {
        const rows = block.type === 'bulletList' ? block.items : [block.children];
        return rows.map((row) => row
            .flatMap((node) => node.type === 'link' ? node.children.map((child) => child.text) : [node.text])
            .join(' '));
    });
    return normalizeWhitespace(values.join(' ')) || normalizeWhitespace(fallback);
}
/**
 * Gallery metadata follows the visible editorial description. It is bounded
 * deterministically so the same copy is used by SEO, Open Graph and Twitter.
 */
export function galleryMetaDescription(visibleDescription) {
    const normalized = normalizeWhitespace(visibleDescription);
    if (normalized.length <= GALLERY_META_DESCRIPTION_MAX_LENGTH)
        return normalized;
    const contentLimit = GALLERY_META_DESCRIPTION_MAX_LENGTH - 1;
    const candidate = normalized.slice(0, contentLimit + 1);
    const wordBoundary = candidate.lastIndexOf(' ');
    const end = wordBoundary >= 100 ? wordBoundary : contentLimit;
    return `${normalized.slice(0, end).replace(/[\s,;:–—-]+$/u, '')}…`;
}
function normalizeWhitespace(value) {
    return value.trim().replace(/\s+/gu, ' ');
}
